import React from "react";
import { Alert, Card, CardBody, Row, Col, CardTitle } from "reactstrap";
import { demoCopy, isDemoLocked } from "../utils/demoConfig";

const ViewLayout = ({ title, headerAction, children, noteAppend, hideSampleDataNotice = false }) => {
  return (
    <>
      <Row>
        <Col>
          <Card>
            <CardBody>
              <Row className={headerAction ? "align-items-center mb-3" : undefined}>
                <Col>
                  <CardTitle tag="h4" className={headerAction ? "mb-0" : undefined}>{title}</CardTitle>
                </Col>
                {headerAction && <Col xs="auto">{headerAction}</Col>}
              </Row>
              {isDemoLocked() && !hideSampleDataNotice && (
                <Alert color="info">
                  <b>Note:</b> {demoCopy.sampleDataNotice}
                  {noteAppend ? <> {noteAppend}</> : null}
                </Alert>
              )}
              {children}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ViewLayout;
